// Force autoplay on all autoplay videos — aggressive mobile/iOS approach
function forceVideoAutoplay() {
  document.querySelectorAll('video-media[autoplay]').forEach(function(videoMedia) {
    videoMedia.setAttribute('loaded', '');
    videoMedia.removeAttribute('show-play-button');
    var video = videoMedia.querySelector('video');
    if (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');
      video.play().catch(function() {});
    }
  });
  document.querySelectorAll('video[autoplay]').forEach(function(video) {
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');
    video.play().catch(function() {});
  });
}

function unlockIOSAutoplay() {
  forceVideoAutoplay();
  document.removeEventListener('touchstart', unlockIOSAutoplay);
  document.removeEventListener('scroll', unlockIOSAutoplay);
}

document.addEventListener("DOMContentLoaded", function() {
  forceVideoAutoplay();
  document.addEventListener('touchstart', unlockIOSAutoplay, { once: true, passive: true });
  document.addEventListener('scroll', unlockIOSAutoplay, { once: true, passive: true });
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.addedNodes.length) forceVideoAutoplay();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const productForm = document.querySelector(".product-form");
  const sampleButton = document.querySelector(".get-sample-button");
  if (productForm && sampleButton) {
    productForm.parentNode.insertBefore(sampleButton, productForm.nextSibling);
  }
});

document.querySelectorAll('.get-sample-button').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const sampleHandle = document.getElementById('sample-product-data').dataset.sampleHandle;
    fetch(`/products/${sampleHandle}.js`)
      .then(res => res.json())
      .then(product => {
        const variantId = product.variants[0].id;
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        const cartDrawer = document.querySelector('cart-drawer');
        let sections = 'cart-drawer,shopify-section-cart-counter';
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const drawerSections = cartDrawer.getSectionsToRender();
          if (Array.isArray(drawerSections) && drawerSections.length) {
            sections = drawerSections.map(section => section.section).join(',');
          }
        }
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        return fetch('/cart/add.js', { method: 'POST', body: formData });
      })
      .then(res => {
        const cartDrawer = document.querySelector('cart-drawer');
        let sections = 'cart-drawer,shopify-section-cart-counter';
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const drawerSections = cartDrawer.getSectionsToRender();
          if (Array.isArray(drawerSections) && drawerSections.length) {
            sections = drawerSections.map(section => section.section).join(',');
          }
        }
        return fetch(`/?sections=${sections}`);
      })
      .then(res => res.json())
      .then(sectionsResponse => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: sectionsResponse });
          cartDrawer.open();
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        window.location.reload();
      })
      .catch(err => { console.error('❌ Add to cart error:', err); });
  });
});